
import React from 'react';
import Box from '@mui/material/Box';
import VisibilityIcon from '@mui/icons-material/VisibilityOutlined';
import { IconButton, Tooltip } from '@mui/material';
import { MuiTable, Progress, TableTopSearch, SingleViewDialog } from 'components';
import BranchesServices from 'services/BranchesServices';

const branchColumns = [
  { accessorKey: 'address', header: 'Address' },
  { accessorKey: 'name', header: 'Name' },
  { accessorKey: 'code', header: 'Branch Code' },
  {
    accessorKey: 'action',
    header: 'Action',
    Cell: ({ row, handleView }) => (
      <Tooltip title="View details">
        <IconButton size="small" color="primary" onClick={() => handleView(row.original)}>
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
    ),
  },
];

const BranchesTab = ({ org }) => {
  const [branchData, setBranchData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [filters, setFilters] = React.useState({
    page: 0,
    limit: 10,
    search: ""
  });
  const [totalItems, setTotalItems] = React.useState(0);
  const [openDialog, setOpenDialog] = React.useState(false);
  const [singleData, setSingleData] = React.useState(null);

  const handleView = (row) => {
    setSingleData(row);
    setOpenDialog(true);
  };

   const setPage = (page) => {
    setFilters(prevFilters => ({
      ...prevFilters,
      page:page-1,
    }));
  };
   const setPageSize = (size) => {
    setFilters(prev => ({
      ...prev, 
      page: 0, 
      limit: size
    }));
  };

  React.useEffect(() => {
    if (!org?.id) {
      return;
    }
    setLoading(true);
    const fetchBranches = async () => {
      try {
        const params = {
          organization_id: org.id,
          search: filters.search,
          page: filters.page,
          limit: filters.limit,
          status: 'Active'
        };
        const response = await BranchesServices.get(params);
        const total = response?.data?.view?.totalItems || response?.data?.totalItems || 0;
        setTotalItems(total);
        const branches = response?.data?.view?.data || response?.data?.data || [];
        if (Array.isArray(branches)) {
          setBranchData(branches.map((b, idx) => ({
            no: idx + 1 + (filters.page - 1) * filters.limit,
            name: b.name || '',
            address: b.address_line1 || '',
            code: b.code || '',
            ...b
          })));
        } else {
          setBranchData([]);
        }
      } catch (err) {
        setBranchData([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    };
    fetchBranches();
  }, [org?.id, filters.page, filters.limit, filters.search]);

  return (
    <>
    
        <TableTopSearch
          title='Branches'
          showSearch={true}
          showTotalWithTitle={true}
          rowCount={totalItems}
          onSubmitSearch={null}
          onSearchChange={(e) => {
            setFilters(prevData => ({
              ...prevData,
              search: e.target.value
            }));
          }}
        />
      {loading ? (
        <Box >
          <Progress />
        </Box>
      ) : (
        <>
          <MuiTable
            columns={branchColumns.map(col => {
              if (col.accessorKey === 'action') {
                return {
                  ...col,
                  Cell: ({ row }) => col.Cell({ row, handleView })
                };
              }
              return col;
            })}
            data={branchData}
            manualPagination={true}
            rowCount={totalItems}
            currentPage={filters.page}
            pageSize={filters.limit}
            onPageChange={setPage}
            onPageSizeChange={setPageSize}
            loading={loading}
          />
         <SingleViewDialog
            open={openDialog}
            onClose={() => setOpenDialog(false)}
            data={{
              title: singleData?.name,
              otherData: [
                {
                  label: "Status",
                  value: singleData?.status
                },
                {
                  label: "Branch Code",
                  value: singleData?.code
                },
                {
                  label: "Description",
                  value: singleData?.description
                },
                {
                  label: "Address Line 1",
                  value: singleData?.address_line1
                },
                {
                  label: "Address Line 2",
                  value: singleData?.address_line2
                },
                {
                  label: "Address Line 3",
                  value: singleData?.address_line3
                },
                {
                  label: "District",
                  value: singleData?.district
                },
                {
                  label: "Contact Number",
                  value: singleData?.contact_no
                },
                {
                  label: "Fax Number",
                  value: singleData?.fax_no
                },
                {
                  label: "Main Branch",
                  value: singleData?.is_main ? "Yes" : "No"
                },
                {
                  label: "Created At",
                  value: singleData?.createdAt ? new Date(singleData.createdAt).toLocaleString() : ""
                },
                {
                  label: "Updated At",
                  value: singleData?.updatedAt ? new Date(singleData.updatedAt).toLocaleString() : ""
                }
              ]
            }}
          />
        </>
      )}
    </>
  );
};

export default BranchesTab;
